import { decorateEmptyGridValues } from "../../../../utils/table/gridUtils";
import {
  FETCH_COMPANIES_LIST,
  FETCH_COMPANIES_INIT,
  FETCH_COMPANIES_DETAIL,
  CREATE_COMPANIES,
  EDIT_COMPANIES,
  INIT_CREATE_COMPANIES_SCREEN,
  TOAST,
  COMPANIES_SAVE_TABLE_STATE,
  DELETE_COMPANIES,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  FETCH_COMPANY_DROPDOWN_LIST,
  SET_SELECTED_COMPANY,
  SWITCH_COMPANY,
} from "../../../types/Systems/Companies.type";

const formFieldValueMap = {
  id: null,
  companyname: "",
  companycode: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  country: "",
  zipcode: "",
  postalcode: "",
  currency: "",
  phone: "",
  url: "",
  fax: "",
  email: "",
  tax_no: "",
  logopath: "",
  planType: "",
  status: "Y",
};

const INITIAL_STATE = {
  companiesListView: [],
  isLoading: false,
  error: null,
  formFieldValueMap,
  isPageLevelError: false,
  isCompaniesCreateSuccess: false,
  isCompaniesCreateError: false,
  isCompaniesDetailSuccess: false,
  isCompaniesDetailError: false,
  isCompaniesEditSuccess: false,
  isCompaniesEditError: false,
  isCompaniesDeleteSuccess: false,
  isCompaniesDeleteError: false,
  shouldOpenDeleteConfirmationPopup: false,
  savedTableState: null,
  companyDropdownList: [],
  selectedCompany: null,
  isSwitchingCompany: false,
  switchCompanySuccess: false,
  switchCompanyError: false,
};

const tranformToGridView = (data) => {
  const companies = data?.companies || [];
  
  const rows = companies.map((item) => {
    const {
      id,
      companyname,
      companycode,
      address1,
      city,
      state,
      country,
      phone,
      email,
      status,
      created_date,
      modified_date,
    } = item;

    const transformedValues = {
      id,
      companyname: companyname || "-",
      companycode: companycode || "-",
      address1: address1 || "-",
      city: city || "-",
      state: state || "-",
      country: country || "-",
      phone: phone || "-",
      email: email || "-",
      status: status === "Y" ? "Active" : "Inactive",
      created_date: created_date || "-",
      modified_date: modified_date || "-",
    };

    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: true,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Company Name",
      dataKey: "companyname",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Company Code",
      dataKey: "companycode",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Address",
      dataKey: "address1",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "City",
      dataKey: "city",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "State",
      dataKey: "state",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Country",
      dataKey: "country",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Phone",
      dataKey: "phone",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Email",
      dataKey: "email",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Created Date",
      dataKey: "created_date",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Modified Date",
      dataKey: "modified_date",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const companiesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPANIES_INIT:
      return { ...INITIAL_STATE, isLoadingPage: true, savedTableState: state.savedTableState, companyDropdownList: state.companyDropdownList, selectedCompany: state.selectedCompany };

    case INIT_CREATE_COMPANIES_SCREEN:
      return {
        ...INITIAL_STATE,
        formFieldValueMap: { ...formFieldValueMap },
        companyDropdownList: state.companyDropdownList,
        selectedCompany: state.selectedCompany,
      };

    case FETCH_COMPANIES_DETAIL.START:
    case CREATE_COMPANIES.START:
    case EDIT_COMPANIES.START:
    case DELETE_COMPANIES.START:
    case FETCH_COMPANIES_LIST.START:
    case FETCH_COMPANY_DROPDOWN_LIST.START:
      return { ...state, isLoading: true };

    case SWITCH_COMPANY.START:
      return { ...state, isSwitchingCompany: true, switchCompanySuccess: false, switchCompanyError: false };

    case FETCH_COMPANIES_LIST.SUCCESS: {
      const data = action.payload;

      let resetState = {
        companiesListView: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isCompaniesCreateSuccess: false,
        isCompaniesCreateError: false,
        savedTableState: state.savedTableState,
        companyDropdownList: state.companyDropdownList,
        selectedCompany: state.selectedCompany,
      };

      if (!data?.companies) {
        return resetState;
      }

      const { datas } = tranformToGridView(data);

      return {
        ...resetState,
        companiesListView: datas,
        paginationInfo: {
          pageSize: data.page_size || 10,
          totalRecords: data.total || 0,
          totalPages: Math.ceil((data.total || 0) / (data.page_size || 10)),
          pageNumber: data.page || 1,
        },
      };
    }

    case FETCH_COMPANIES_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        companiesListView: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
      };
    }

    case FETCH_COMPANIES_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isCompaniesDetailSuccess: true,
      };
    }

    case FETCH_COMPANIES_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isCompaniesDetailSuccess: false,
        isCompaniesDetailError: true,
      };
    }

    case CREATE_COMPANIES.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isCompaniesCreateSuccess: true,
        isCompaniesCreateError: false,
      };
    }

    case CREATE_COMPANIES.ERROR: {
      return {
        ...state,
        isLoading: false,
        isCompaniesCreateSuccess: false,
        isCompaniesCreateError: true,
      };
    }

    case EDIT_COMPANIES.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isCompaniesEditSuccess: true,
        isCompaniesEditError: false,
      };
    }

    case EDIT_COMPANIES.ERROR: {
      return {
        ...state,
        isLoading: false,
        isCompaniesEditSuccess: false,
        isCompaniesEditError: true,
      };
    }

    case TOAST.RESET: {
      return {
        ...state,
        isCompaniesCreateSuccess: false,
        isCompaniesCreateError: false,
        isCompaniesEditSuccess: false,
        isCompaniesEditError: false,
        isCompaniesDeleteSuccess: false,
        isCompaniesDeleteError: false,
      };
    }

    case DELETE_COMPANIES.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isCompaniesDeleteSuccess: true,
        isCompaniesDeleteError: false,
      };
    }

    case DELETE_COMPANIES.ERROR: {
      return {
        ...state,
        isLoading: false,
        isCompaniesDeleteSuccess: false,
        isCompaniesDeleteError: true,
      };
    }

    case COMPANIES_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup: action.payload,
      };
    }

    case FETCH_COMPANY_DROPDOWN_LIST.SUCCESS: {
      const companies = action.payload || [];
      const storedCompanyId = localStorage.getItem('companyId');
      
      let selectedCompany = state.selectedCompany;
      
      if (!selectedCompany) {
        if (storedCompanyId) {
          selectedCompany = companies?.find(company => company.companyId === parseInt(storedCompanyId));
        }
        
        if (!selectedCompany) {
          selectedCompany = companies?.find(company => company.isDefault) || (companies.length > 0 ? companies[0] : null);
        }
        
        if (selectedCompany) {
          localStorage.setItem('companyId', selectedCompany.companyId);
        }
      }
      
      return {
        ...state,
        companyDropdownList: companies,
        isLoading: false,
        selectedCompany: selectedCompany,
      };
    }

    case FETCH_COMPANY_DROPDOWN_LIST.ERROR: {
      return {
        ...state,
        isLoading: false,
        companyDropdownList: [],
      };
    }

    case SET_SELECTED_COMPANY: {
      if (action.payload) {
        localStorage.setItem('companyId', action.payload.companyId);
      }
      
      return {
        ...state,
        selectedCompany: action.payload,
      };
    }

    case SWITCH_COMPANY.SUCCESS: {
      const { companyId, companyName, companyCode, menuAccess } = action.payload;
      
      const cleanTitle = (title = "") => title.replace(/[\/&]/g, "").trim();
      
      const generateCamelCaseMenuKey = (title = "") => {
        const words = title.trim().split(" ");
        if (words.length === 0) return "menu";
        const [firstWord, ...restWords] = words;
        const camelKey =
          firstWord.toLowerCase() +
          restWords
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join("");
        return camelKey + "Menu";
      };
      
      const getScreenPermissionInfo = (item) => ({
        view: Boolean(item.view),
        create: Boolean(item.createCrud),
        edit: Boolean(item.editCrud),
        delete: Boolean(item.canDelete),
        title: cleanTitle(item.title || ""),
      });
      
      const processMenuAccess = (menuItems) => {
        const access = {};
        const menuIdMapping = {};
        const keyCountMap = {};
        
        const flattenMenu = (items) => {
          if (!Array.isArray(items)) return;
          
          items.forEach((item) => {
            if (item.title) {
              const baseKey = generateCamelCaseMenuKey(cleanTitle(item.title));
              let key = baseKey;
              
              if (keyCountMap[baseKey]) {
                key = `${baseKey}${keyCountMap[baseKey] + 1}`;
                keyCountMap[baseKey]++;
              } else {
                keyCountMap[baseKey] = 1;
              }
              
              access[key] = getScreenPermissionInfo(item);
              
              if (item.menuId) {
                const titleKey = cleanTitle(item.title).toLowerCase();
                menuIdMapping[titleKey] = {
                  menuId: item.menuId,
                  title: item.title,
                  url: item.url || "",
                };
              }
            }
            
            if (item.accessDTOList && Array.isArray(item.accessDTOList)) {
              flattenMenu(item.accessDTOList);
            }
          });
        };
        
        flattenMenu(menuItems);
        return { access, menuIdMapping };
      };
      
      const { access, menuIdMapping } = processMenuAccess(menuAccess || []);
      localStorage.setItem('companyId', companyId);
      localStorage.setItem('menuAccess', JSON.stringify(access));
      localStorage.setItem('menuIdMapping', JSON.stringify(menuIdMapping));
      
      return {
        ...state,
        isSwitchingCompany: false,
        switchCompanySuccess: true,
        switchCompanyError: false,
        selectedCompany: {
          companyId,
          companyName,
          companyCode,
        },
      };
    }

    case SWITCH_COMPANY.ERROR: {
      return {
        ...state,
        isSwitchingCompany: false,
        switchCompanySuccess: false,
        switchCompanyError: true,
      };
    }

    default:
      return state;
  }
};
